// extracted by mini-css-extract-plugin
export default {"root":"styles_root__MFf8U","import-button":"styles_import-button__z+lNG","question-button":"styles_question-button__grQGi","spin":"styles_spin__7DhrQ"};